/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type ExecutionSource = typeof ExecutionSource[keyof typeof ExecutionSource];


export const ExecutionSource = {
  api: 'api',
  admin_api: 'admin_api',
  publisher_api: 'publisher_api',
  worker: 'worker',
  system: 'system',
} as const;
